import { Icon, Text, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslationWithPrefix } from '@hotjar/translations';

export type BundleDeductionState = 'removed' | 'applied' | null;

const S = {
  Discount: styled(Text)`
    display: flex;
    align-items: center;
    gap: ${tokens.spacer.x0};
  `,
};

export type DiscountType = 'yearly' | 'bundle' | 'agency' | 'legacy';

interface Props {
  discount: DiscountType;
  state: Exclude<BundleDeductionState, null>;
  noIcon?: boolean;
  className?: string;
  percentage?: number;
  useDefaultColor?: boolean;
}

function getTextColor(
  state: Exclude<BundleDeductionState, null>,
  useDefaultColor: boolean,
): keyof typeof tokens.ALIAS_TEXT_COLORS {
  if (useDefaultColor) {
    return 'text_default';
  }

  switch (state) {
    case 'applied':
      return 'text_success';
    case 'removed':
      return 'text_danger';
    default:
      return 'text_default';
  }
}

export function Discount({
  discount,
  state,
  noIcon = false,
  className,
  percentage,
  useDefaultColor = true,
}: Props): JSX.Element {
  const { t } = useTranslationWithPrefix('checkout:subscriptions.cost.discounts');

  const textColor = getTextColor(state, useDefaultColor);

  return (
    <S.Discount textColor="text_light" className={className}>
      {!noIcon && (
        <Icon icon={state === 'removed' ? 'warning' : 'special_offer'} color={textColor} />
      )}
      <Text textType="caption" textColor={textColor}>
        {t(`${discount}-discount`, { context: state, percentage })}
      </Text>
    </S.Discount>
  );
}
